import { ReactNode } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SliderArrowRightSVG from "../../resources/svg/functional/SliderArrowRightSVG";
import SliderArrowLeftSVG from "../../resources/svg/functional/SliderArrowLeftSVG";

interface MainPageSliderProps<T> {
    entities: T[];
    mapCallback: (entity: T) => ReactNode;
}

const settings = {
    className: "center",
    centerMode: true,
    centerPadding: "525px",
    slidesToShow: 1,
    speed: 500,
    responsive: [
        {
            breakpoint: 1750,
            settings: {
                centerPadding: "425px",
            },
        },
        {
            breakpoint: 1550,
            settings: {
                centerPadding: "375px",
            },
        },
        {
            breakpoint: 1450,
            settings: {
                centerPadding: "325px",
            },
        },
        {
            breakpoint: 1200,
            settings: {
                centerPadding: "275px",
            },
        },
        {
            breakpoint: 1100,
            settings: {
                centerPadding: "225px",
            },
        },
        {
            breakpoint: 1000,
            settings: {
                centerPadding: "175px",
            },
        },
        {
            breakpoint: 900,
            settings: {
                centerPadding: "135px",
            },
        },
        {
            breakpoint: 800,
            settings: {
                centerPadding: "25px",
            },
        },
    ],
};

function MainPageSlider<T>(props: MainPageSliderProps<T>) {
    return (
        <div className="relative slider-container mb-[220px] dmax2:mb-[144px]">
            <Slider
                {...{
                    ...settings,
                    infinite: props.entities.length > 1,
                }}
                nextArrow={<SliderArrowRightSVG />}
                prevArrow={<SliderArrowLeftSVG />}
            >
                {props.entities.map(props.mapCallback)}
            </Slider>
        </div>
    );
}

export default MainPageSlider;
